<mat-dialog-content class="mat-typography">
  <h2 mat-dialog-title>Bulk Edit</h2>
  <div class="drop-down-1">
    <ul>
      <li *ngFor="let t of dropDownFields" (click)="testClick(t.field)">{{t.field}}</li>
    </ul>
  </div>

  <div class="drop-down-2">
    <ul>
      <li *ngFor="let t of asmTags" (click)="testClick(t.value)">{{t.value}}</li>
    </ul>
  </div>

  <div class="grid">
    <div class="fn-lib-top-area">
      <h3>Function Library</h3>
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput placeholder="" value="" [(ngModel)]="fnLibSearchValue" (input)="fnLibSearch($event)">
        <button *ngIf="fnLibSearchValue.length" matSuffix mat-icon-button aria-label="Clear" (click)="fnLibSearchClear()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="fn-lib" (click)="hidePopup()">
      <mat-card *ngFor="let item of library">
        <mat-card-title>{{item.title}}</mat-card-title>
        <mat-card-subtitle>{{item.subtitle}}</mat-card-subtitle>
        <ngx-codemirror
          class="example-code"
          #codeMirror2
          [(ngModel)]="item.fn"
          [options]="{
            readOnly: true,
            scrollbarStyle: null,
            showCursorWhenSelecting: false,
            cursorBlinkRate: -1
          }"
        ></ngx-codemirror>
        <mat-card-actions>
          <button (click)="addFnLibrary(item.fn)" mat-button>Add</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
<!--  <div>-->
<!--        <div class="fn-variables" (click)="hidePopup()">-->
<!--          <h3>Variables</h3>-->
<!--          <div class="grid-btn-items">-->
<!--            <div class="grid-btn-item" *ngFor="let item of rows2">-->
<!--              <button (click)="clickTag(item.field)" mat-raised-button color="primary" [style.background-color]="item.color">{{item.name}}</button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--  </div>-->
  <div class="fn" style="width:100%;">
    <div class="fn-lib-bottom-area" (click)="hidePopup()">
      <h3>Function</h3>
      <button mat-raised-button [matMenuTriggerFor]="addFieldMenu">+ Add Field</button>
      <mat-menu class="add-field-menu" #addFieldMenu="matMenu">
        <button *ngFor="let item of rows2" (click)="clickTag(item.field)" mat-menu-item>{{item.name}}</button>
      </mat-menu>
    </div>
    <ngx-codemirror
      #codeMirror
      [(ngModel)]="codemirrorContent"
      [options]="codemirrorConfig"
      [autoFocus]="true"
      (cursorActivity)="cursorActivity($event)"
      (ngModelChange)="setEditorContent($event)"
    ></ngx-codemirror>
  </div>
  <div class="bottom-grid-area">
    <section class="example-section">
      <mat-checkbox [(ngModel)]="backupChecked" (click)="onBackupClick()" class="create-backup-checkbox">Create Database Backup</mat-checkbox>
      <mat-form-field *ngIf="backupChecked" class="example-full-width" appearance="fill">
        <mat-label>Backup message</mat-label>
        <input #backupMessageElement [(ngModel)]="backupMessage" matInput placeholder="" value="">
      </mat-form-field>
    </section>
    <a style="display: inline-block; margin-bottom: 5px;" href="https://www.advancedshippingmanager.com/Advanced-Shipping-Manager-Variables.pdf" target="_blank">ASM Variables</a>
  </div>
    <div *ngIf="pending">
      <mat-progress-bar class="bulk-dialog-loader" mode="indeterminate"></mat-progress-bar>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" [disabled]="disableBtn || pending" (click)="onSubmit()">Submit changes</button>
</mat-dialog-actions>
